export var modifyA = function modifyA(state, name) {
  state.resName = name;
};
export var modifyB = function modifyB(state, name) {
  state.resName = name;
};